import React from "react";

const SortIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path d="M10 26.586V2H8V26.586l-3.95-3.95L2.636 24.05l5.657 5.657a1 1 0 0 0 1.414 0l5.657-5.657L13.95 22.636zM29.364 7.95L23.707 2.293a1 1 0 0 0-1.414 0L16.636 7.95 18.05 9.364 22 5.414V30h2V5.414l3.95 3.95z" />
  </svg>
);

export default SortIconSVG;
